import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { useClientId } from '../../_hooks/useClientId';

interface Params {
  clientId: number;
  inviteId: string;
}

const acceptRequest = async ({ clientId, inviteId }: Params): Promise<null> => {
  return authFetch(
    urlWithParams('/BeFi20/survey/AcceptInvite', { clientId, alignment: inviteId }),
    {
      method: 'POST',
    },
  );
};

export const useAcceptRequestMutation = () => {
  const queryClient = useQueryClient();
  const clientId = useClientId();

  return useMutation(acceptRequest, {
    async onSuccess() {
      await queryClient.invalidateQueries(queryKeys.overview(clientId));
    },
  });
};
